import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {Person} from '../../person/person';
import {Entity} from '../../entity/entity';
import {PersonService} from '../../services/person-service';
import {EntityService} from '../../services/entity-service';
import {StringUtils} from '../../utils/string-utils';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';
import {MatProgressSpinner} from '@angular/material/progress-spinner';


@Component({
    selector: 'skyport-contact-dialog',
    templateUrl: './skyport-contact-dialog.component.html',
    styleUrls: ['./skyport-contact-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinner, FormsModule, MatDialogActions, MatButton]
})
export class SkyportContactDialogComponent {
  private readonly personService = inject(PersonService);
  private readonly entityService = inject(EntityService);
  readonly dialogRef = inject<MatDialogRef<SkyportContactDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  public readonly loadedPerson = signal<Person>(undefined!);
  public entity: Entity;
  public readonly isBusy = signal<boolean>(undefined!);
  public readonly errorMessage = signal<string>(undefined!);

  constructor
  () {
    const data = this.data;

    this.entity = data.entity as Entity;
    this.getSkyportContact();
  }

  public saveAndClose(): void {
    this.isBusy.set(true);
    this.errorMessage.set(null!);
    this.validateRequiredFields();
    if (!this.errorMessage() || this.errorMessage().length == 0) {
      this.personService.saveSkyportContact(this.loadedPerson(), this.entity).subscribe(result => {
        this.dialogRef.close(this.entity);
      }, error => this.handleError(error));
    } else {
      this.isBusy.set(false);
    }
  }

  private getSkyportContact(): void {
    this.personService.getSkyportContact(this.entity).subscribe(result => {
      this.loadedPerson.set(result);
      if (this.loadedPerson() == null) {
        this.loadedPerson.set(new Person());
      }
    }, error => this.handleError(error));
  }

  private validateRequiredFields(): void {
    if (!this.loadedPerson().firstName || this.loadedPerson().firstName.length == 0) {
      this.errorMessage.set('Contact First Name is required');
    } else if (!this.loadedPerson().lastName || this.loadedPerson().lastName.length == 0) {
      this.errorMessage.set('Contact Last Name is required');
    } else if (!this.loadedPerson().defaultPhoneNumber || this.loadedPerson().defaultPhoneNumber.length == 0) {
      this.errorMessage.set('Contact Phone Number is required');
    } else if (!this.loadedPerson().emailAddress.emailAddress || this.loadedPerson().emailAddress.emailAddress.length == 0) {
      this.errorMessage.set('Contact E-Mail is required');
    }
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage.set(StringUtils.getErrorMessage(error));
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

}
